import { useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { rolesColors, rolesTranslations } from '../../services/data'
import { getReplacementMembers } from '../../services/util'

export function ReassignMissions({ closePopup, member, vids = [], team, removeTeamMember, transfer = true }) {
    const navigate = useNavigate()
    const admin = team.members.find(m => m.roles.includes('admin'))
    const videos = useRef(vids.map(video => ({ status: video.status, title: video.ideaMaker.titles[0], thumbnail: video.ideaMaker.thumbnails[0], _id: video._id })))
    const [showImg, setShowImg] = useState(false)
    const [options, setOptions] = useState(videos.current.map(video => ({
        selceted: admin._id,
        availableMembers: getReplacementMembers(team, video.status.level, member._id)
    })))

    const onSelectChange = (e, idx) => {
        let newOptions = [...options]
        newOptions[idx].selceted = e.target.value
        setOptions(newOptions)
    }

    const onDelete = async () => {
        const transfer = videos.current.map((video, idx) => ({
            videoId: video._id,
            newWorkerId: options[idx].selceted
        }))
        await removeTeamMember(member._id, transfer)
        closePopup()
    }

    return <>
        <div className="screen blur" onClick={closePopup} />

        <section className='popup reassign-missions'>
            {(videos.current.length && !member.roles.includes('thumbnailEditor') || !transfer) ? <>
                <h1 style={{ marginBottom: '20px', textAlign: 'center' }}>
                    {transfer ? 'לפני שתוציא את ' + member.name + ' מהצוות, יש להעביר את המשימות שלו לעובדים אחרים' : 'המשימות של ' + member.name + ' :'}
                </h1>
                <div className='videos-container'>
                    {videos.current.map((video, idx) => <div key={video._id} className='video-line'>
                        <p onClick={() => navigate(`/video/${video._id}`)} onMouseEnter={() => { if (video.thumbnail) setShowImg(video._id) }} onMouseLeave={() => setShowImg(false)}>{video.title}
                            <span className={rolesColors[video.status.level] + '-text'}> ({rolesTranslations[video.status.level]})</span> </p>
                        {showImg === video._id && <img src={video.thumbnail} alt={video.title} />}
                        {transfer && <select onChange={e => onSelectChange(e, idx)}>
                            {options[idx].availableMembers.map(m => <option key={m._id || m.name} value={m._id || m.name}>{m.name}</option>)}
                        </select>}
                    </div>)}
                </div>
            </> :
                <h1 style={{ marginBottom: '20px', textAlign: 'center' }}>האם אתה בטוח שברצונך להסיר את {member.name} מהצוות?</h1>}

            <div className='buttons-wrapper' style={{ marginTop: '40px' }}>
                <button className={transfer ? 'lighter' : 'bolder'} onClick={closePopup}>סגור</button>
                {transfer && <button className='bolder red' onClick={onDelete}>הסר</button>}
            </div>
        </section>
    </>
}